import * as React from 'react';
import { formatoDecimal } from '../../../../utilities/formatoNumeros';
import LiquidacionDetalleTabla from './LiquidacionDetalleTabla';

const TABLE_HEAD = (
    <tr>
        <th scope="col">Orden Ref</th>
        <th scope="col">Tipo</th>
        <th scope="col">Fecha</th>
        <th scope="col">Importe</th>
        <th scope="col">Acción</th>
    </tr>
);

export default class NovedadesDeLiquidacionBorrador extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            novedades: props.novedades ?? [],
            seleccionarTodo: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.novedades !== this.props.novedades) {
            const novedadesChecked = (this.props.novedades ?? []).map(x => ({
                ...x,
                checked: x.idLiquidacion != 0,
            }));
            this.setState({ novedades: novedadesChecked });
        }
    }

    handleChangeCheckbox = (id) => {
        this.setState((prevState) => {
            const novedades = prevState.novedades.map((novedad) => {
                if (novedad.idNovedad === id) {
                    return {
                        ...novedad,
                        checked: !novedad.checked,
                    };
                }
                return novedad;
            });
            return { novedades };
        });
    };

    handleSelectAllCheckbox(seleccionarTodo) {
        this.setState((prevState) => {
            const novedades = prevState.novedades.map((novedad) => ({
                ...novedad,
                checked: seleccionarTodo,
            }));
            return { novedades, seleccionarTodo };
        });
    }

    render = () => (
        <LiquidacionDetalleTabla
            title="Novedades"
            data={this.state.novedades}
            isLoading={this.props.isLoading}
            loadingMessage="Cargando novedades del borrador..."
            emptyMessage="No hay novedades para esta liquidación"
            tableHead={TABLE_HEAD}
            renderRow={(novedad, i, globalIndex) => (
                <tr key={novedad.idNovedad ?? globalIndex} className="hover-background-color">
                    <td><small>{novedad.ordenDeReferencia}</small></td>
                    <td><small>{novedad.detalleTipoNovedad}</small></td>
                    <td><small>{new Date(novedad.fechaNovedad).toLocaleDateString()}</small></td>
                    <td><small>${formatoDecimal(novedad.importe)}</small></td>
                    <td><small>{novedad.detalleSubTipoNovedad}</small></td>
                </tr>
            )}
        />
    );
}
